import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./Sidebar";
import Header from "./Header";
import DashboardFooter from "./DashboardFooter";
import { Helmet } from "react-helmet";

// CSS العام
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
/>;

const AdminDashboardLayout = ({ pageTitle, children }) => {
  const { t, i18n } = useTranslation();
  const direction = i18n.language === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    AOS.init({ duration: 800 });
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.lang = i18n.language;
    document.title = pageTitle || "لوحة التحكم";
  }, [pageTitle, direction, i18n.language]);

  return (
    <div dir={direction}>
      <Helmet>
        <link rel="stylesheet" href="/assets-v2/css/dashboard.css" />
      </Helmet>

      <div
        className="admin-dashboard d-flex"
        style={{ fontFamily: "Tajawal, Montserrat, sans-serif" }}
        dir={direction}
      >
        {direction === "rtl" ? (
          <>
            <Sidebar />
            <div className="main-wrapper flex-grow-1 d-flex flex-column">
              <Header />
              <main className="main-content flex-grow-1">
                <div className="container-fluid">{children}</div>
              </main>
              {/* <DashboardFooter /> */}
            </div>
          </>
        ) : (
          <>
            <div className="main-wrapper flex-grow-1 d-flex flex-column">
              <Header />
              <main className="main-content flex-grow-1">
                <div className="container-fluid">{children}</div>
              </main>
              {/* <DashboardFooter /> */}
            </div>
            <Sidebar />
          </>
        )}

        <ToastContainer />
      </div>
    </div>
  );
};

export default AdminDashboardLayout;
